import React from 'react';

import { StoreContext } from '../../store/store';
import Loader from '../loader/loader';
import './layout.scss';

export const Layout = ({ children }) => {
  const { state } = React.useContext(StoreContext);
  return (
    <Loader isLoadingAPIs={[state.isLoading]}>
      <div className="rc-layout">{children}</div>
    </Loader>
  );
};
